import { Phone, Mail, MapPin } from "lucide-react";

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-foreground text-white" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
          {/* Brand */}
          <div className="md:col-span-2">
            <span 
              className="font-semibold text-2xl tracking-wide"
              style={{ fontFamily: 'Space Grotesk, sans-serif' }}
            >
              Salgsrenovering
            </span>
            <p className="mt-4 text-white/70 max-w-md leading-relaxed">
              Vi hjælper dig med at maksimere din boligs værdi gennem strategisk 
              renovering. Professionel rådgivning og kvalitetshåndværk.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-semibold text-sm uppercase tracking-wider mb-4">
              Navigation
            </h4>
            <ul className="space-y-3">
              {[
                { href: "#services", label: "Services" },
                { href: "#om-os", label: "Om Os" },
                { href: "#kontakt", label: "Kontakt" },
              ].map((link) => (
                <li key={link.href}>
                  <a 
                    href={link.href}
                    className="text-white/70 hover:text-white transition-colors"
                    data-testid={`footer-link-${link.href.slice(1)}`}
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-semibold text-sm uppercase tracking-wider mb-4">
              Kontakt
            </h4>
            <ul className="space-y-3">
              <li>
                <a 
                  href="tel:+4561362199" 
                  className="flex items-center gap-2 text-white/70 hover:text-white transition-colors"
                  data-testid="footer-phone"
                >
                  <Phone className="w-4 h-4" />
                  +45 6136 2199
                </a>
              </li>
              <li>
                <a 
                  href="mailto:info@salgsrenovering.dk"
                  className="flex items-center gap-2 text-white/70 hover:text-white transition-colors"
                  data-testid="footer-email"
                >
                  <Mail className="w-4 h-4" />
                  info@salgsrenovering.dk
                </a>
              </li>
              <li className="flex items-center gap-2 text-white/70">
                <MapPin className="w-4 h-4" />
                Hørsholm, Danmark
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-8 border-t border-white/10 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-sm text-white/50">
            © {currentYear} Salgsrenovering.dk. Alle rettigheder forbeholdes.
          </p>
          <div className="flex gap-6 text-sm text-white/50">
            <a href="#" className="hover:text-white transition-colors">
              Privatlivspolitik
            </a>
            <a href="#" className="hover:text-white transition-colors">
              Vilkår og betingelser
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
